import axiosInstance from './axiosInstance';

const salesService = {
  listarOrdenes: async (params) => {
    const response = await axiosInstance.get('/sales/orders', { params });
    return response.data;
  },

  crearOrden: async (data) => {
    const response = await axiosInstance.post('/sales/orders', data);
    return response.data;
  },

  obtenerOrden: async (id) => {
    const response = await axiosInstance.get(`/sales/orders/${id}`);
    return response.data;
  },

  // Transición de estado única: status = 'BORRADOR' | 'APROBADA' | 'DESPACHADA' | 'CANCELADA'
  cambiarEstadoOrden: async (id, status) => {
    const response = await axiosInstance.patch(`/sales/orders/${id}/status`, { status });
    return response.data;
  },

  getNextOrderNumber: async () => {
    const response = await axiosInstance.get('/sales/orders/next-number');
    return response.data;
  },

  getTransactionCategories: async () => {
    const response = await axiosInstance.get('/sales/categories');
    return response.data;
  },

  actualizarHeader: async (id, data) => {
    const response = await axiosInstance.patch(`/sales/orders/${id}/update-header`, data);
    return response.data;
  },

  autoGuardarOrden: async (data) => {
    const response = await axiosInstance.post('/sales/orders/auto-save', data);
    return response.data;
  },

  agregarLinea: async (orderId, data) => {
    const response = await axiosInstance.post(`/sales/orders/${orderId}/details`, data);
    return response.data;
  },

  eliminarLinea: async (detailId) => {
    const response = await axiosInstance.delete(`/sales/orders/details/${detailId}`);
    return response.data;
  },

  // Asignar inventario a una línea: assignments = [{ lote_id, quantity }]
  asignarInventario: async (detailId, assignments) => {
    const response = await axiosInstance.post(`/sales/orders/details/${detailId}/assign`, { assignments });
    return response.data;
  },

  // Liberar una asignación específica
  liberarAsignacion: async (assignmentId) => {
    const response = await axiosInstance.delete(`/sales/orders/assignments/${assignmentId}`);
    return response.data;
  },

  actualizarLinea: async (detailId, data) => {
    const response = await axiosInstance.patch(`/sales/orders/details/${detailId}`, data);
    return response.data;
  },
};

export default salesService;
